import type { Permission } from '../entities/Access';
import { usePermission } from '../hooks/usePermission.hook';

interface PermissionGuardProps {
  permission: Permission | Permission[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function PermissionGuard({
  permission,
  children,
  fallback = null,
}: PermissionGuardProps) {
  const { hasPermission } = usePermission();

  const permissions = Array.isArray(permission) ? permission : [permission];

  return hasPermission(...permissions) ? children : fallback;
}
